import { createFileRoute } from "@tanstack/react-router";
import { type SubmitEvent, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/Button";
import { Field } from "@/components/ui/Field";
import { authClient } from "@/lib/authClient";

export const Route = createFileRoute("/recuperar")({ component: ForgotPasswordPage });

// FormData.get() puede devolver un File, así que String(...) directo dispara
// no-base-to-string. El campo de este formulario es siempre de texto.
function fieldValue(data: FormData, name: string): string {
  const value = data.get(name);
  return typeof value === "string" ? value : "";
}

function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [sent, setSent] = useState(false);

  async function handleSubmit(event: SubmitEvent<HTMLFormElement>) {
    event.preventDefault();
    const email = fieldValue(new FormData(event.currentTarget), "email");

    // redirectTo debe ser absoluta: better-auth resuelve una ruta relativa
    // contra su propio baseURL (el origen de la API), no el de esta app. Con
    // "/definir-contrasena" a secas, el enlace del correo termina apuntando a
    // `${API_ORIGIN}/definir-contrasena`, una ruta que la API no expone (ver
    // GET /reset-password/:token en el paquete better-auth, que resuelve
    // `callbackURL` con `new URL(callbackURL, ctx.baseURL)`). Con el origen
    // del propio front (window.location.origin) el enlace cae en la SPA,
    // igual que ya hace `${opts.appOrigin}/definir-contrasena` en el flujo de
    // invitación (apps/api/src/modules/users/users.routes.ts).
    //
    // Se responde igual exista o no la cuenta, para no filtrar
    // qué correos están dados de alta.
    await authClient.requestPasswordReset({
      email,
      redirectTo: `${window.location.origin}/definir-contrasena`,
    });
    setSent(true);
  }

  return (
    <div className="grid min-h-dvh place-items-center bg-bg px-4">
      <div className="w-full max-w-[360px] rounded-[3px] border border-line bg-card p-8">
        <h1>{t("auth.resetTitle")}</h1>

        {sent ? (
          <p className="mt-4 text-[13px] text-ink2">{t("auth.resetSent")}</p>
        ) : (
          <form onSubmit={(event) => void handleSubmit(event)} className="mt-6 flex flex-col gap-4">
            <Field label={t("auth.email")} name="email" type="email" required />
            <Button type="submit">{t("auth.resetSend")}</Button>
          </form>
        )}
      </div>
    </div>
  );
}
